module.exports = __webpack_public_path__ + "img/logo.6713a3be.png";